import React from "react";
import { Button } from "@/components/ui/button";

export const EmptyState = ({ icon: Icon, title, description, actionLabel, onAction, testId }) => (
  <div data-testid={testId} className="flex flex-col items-center justify-center rounded-xl border border-dashed border-[color:var(--hh-line)] bg-white px-6 py-14 text-center">
    {Icon && (
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--hh-amber-50)] text-[color:var(--hh-amber-600)]">
        <Icon className="h-6 w-6" />
      </div>
    )}
    <h3 className="font-display text-lg font-semibold text-[color:var(--hh-ink)]">{title}</h3>
    {description && <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p>}
    {actionLabel && onAction && (
      <Button onClick={onAction} className="mt-5 rounded-xl bg-[hsl(var(--primary))] text-white hover:bg-[var(--hh-amber-600)]">
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;
